import { NotificacionApi } from '@/shared/formalizacion-client';

export default class NotificacionService extends NotificacionApi {}
